import { usePerformanceDetail } from "@features/ax/assetRegistry/assets/hooks";
import { logEvent } from "@shared/analytics/analytics";
import { PageHeader } from "@shared/components/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { Cpu, Info } from "lucide-react";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { KPICards } from "./PerformanceKPICards";

const AssetSpecificDataCard: React.FC<{
  assetType: string;
  specificFields: Record<string, any>;
}> = ({ assetType, specificFields }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {assetType} Operational Data
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {specificFields?.map((item, index) => (
            <div key={index} className="p-3 border rounded-lg">
              <div className="flex items-start justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">
                  {item.label}
                </span>
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger>
                      <Info className="h-3 w-3 text-gray-400" />
                    </TooltipTrigger>
                    <TooltipContent className="max-w-xs bg-white border shadow-lg">
                      <p className="text-sm">{item.info}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
              <div className="flex items-baseline gap-1">
                <span className="text-lg font-semibold text-blue-600">
                  {item.value}
                </span>
                {item.unit && (
                  <span className="text-sm text-gray-500">{item.unit}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export const AssetPerformanceTab: React.FC = () => {
  const { id } = useParams();
  useEffect(() => {
    logEvent("asset_performance_tab_viewed");
  }, []);
  const { data: performanceData } = usePerformanceDetail(id);
  return (
    <div className="space-y-6">
      {/* Global Filters */}
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
          <Cpu className="h-5 w-5 text-indigo-600" />
        </div>
        <div>
          <PageHeader
            title="Asset Performance Overview"
            subtitle="Comprehensive asset health, performance, and financial metrics"
          />
        </div>
      </div>

      <KPICards data={performanceData} />

      {/* <AssetSpecificDataCard
        assetType={performanceData?.assetType}
        specificFields={performanceData?.pumpOperationalData}
      /> */}

      {/* <PerformanceTables
        performanceData={performanceData?.performanceHistory}
      /> */}
    </div>
  );
};
